import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { AdminSurveyService } from "../../services/admin-survey.service";
import { DialogUtils } from "../../helper/dialog.helper";

let LeaveCampaignSurvey = {
    selector: "vcLeaveCampaignSurvey",
    templateUrl:
        "/angular/components/profile/leave-campaign-survey.component.html",
    bindings: {},
    controller: class LeaveCampaignSurveyController {
        public deletion: any = {};
        public survey: any;
        public submitClicked = false;
        public sending = false;
        public extraAnswerOpen = false;

        public __env: any;
        private dialog: DialogUtils;

        private adminSurveyService: AdminSurveyService;
        private campaignDataProvider: CampaignDataProvider;

        constructor(
            __env: any,
            DialogUtils: DialogUtils,
            AdminSurveyService: AdminSurveyService,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.__env = __env;
            this.dialog = DialogUtils;

            this.adminSurveyService = AdminSurveyService;
            this.campaignDataProvider = CampaignDataProvider;

            this.adminSurveyService
                .leaveCampaignSurvey()
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                    } else {
                        console.log(json);
                    }
                });
        }

        updateSubmitClicked(bool: boolean): void {
            this.submitClicked = bool;
        }

        submitSurvey(): void {
            this.sending = true;
            this.survey.campaignid =
                this.campaignDataProvider.activeCampaign.campaignid;
            this.adminSurveyService
                .submitLeaveCampaignSurvey(this.survey)
                .then((json: any) => {
                    if (json.success) {
                        this.dialog.hide(this.deletion);
                    }
                });
        }

        answerSelected(question: any, answer: any): void {
            if (question.sqid == "4" && answer) {
                if (answer.aid == "3" || answer.aid == "4") {
                    this.extraAnswerOpen = true;
                } else {
                    this.extraAnswerOpen = false;
                }
            }

            if (question.atid == "1") {
                question.answer = answer;
            }
        }

        leavingFeedbackOpen(): boolean {
            angular.forEach(this.survey.questions, (question: any) => {
                if (
                    question.sqid == "4" &&
                    question.answer &&
                    (question.answer.aid == "3" || question.answer.aid == "4")
                ) {
                    return true;
                }
            });
            return false;
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("profile")
    .component(LeaveCampaignSurvey.selector, LeaveCampaignSurvey);
